import { motion, useReducedMotion } from "framer-motion";
import { MapPin } from "lucide-react";

const SUBURBS = [
  "Morphett Vale",
  "Noarlunga",
  "Reynella",
  "Hallett Cove",
  "Seaford",
  "Christies Beach",
  "Marion",
  "Glenelg",
  "Happy Valley",
  "Aldinga",
];

const EASE = [0.16, 1, 0.3, 1];

export const ServiceArea = () => {
  const reduce = useReducedMotion();

  return (
    <section
      id="areas"
      data-testid="areas-section"
      className="grain relative overflow-hidden bg-navy py-20 text-white md:py-28"
    >
      <span
        aria-hidden="true"
        className="text-outline-faint pointer-events-none absolute -left-4 bottom-0 select-none font-display text-[22vw] font-bold uppercase leading-none"
      >
        South
      </span>

      <div className="safe-x relative mx-auto grid max-w-7xl gap-12 lg:grid-cols-[380px_1fr] lg:gap-20">
        <motion.div
          initial={reduce ? false : { opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
          data-testid="areas-stat-box"
          className="h-fit border-4 border-orange bg-navy px-8 py-10"
          style={{ clipPath: "polygon(0 0, 100% 0, 100% calc(100% - 30px), calc(100% - 30px) 100%, 0 100%)" }}
        >
          <p className="font-display text-7xl font-bold leading-none text-orange md:text-8xl">100%</p>
          <p className="mt-4 font-display text-xl font-medium uppercase tracking-[0.15em] text-white/90">
            Southern Adelaide, covered
          </p>
          <p className="mt-3 text-sm text-white/60 md:text-base">
            South of the city is our patch &mdash; not an afterthought.
          </p>
        </motion.div>

        <motion.div
          initial={reduce ? false : { opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE, delay: 0.15 }}
          className="flex flex-col justify-center"
        >
          <p className="eyebrow">Service area</p>
          <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] sm:text-5xl">
            Local to the south. <span className="text-orange">On time, every time.</span>
          </h2>
          <p className="mt-6 max-w-xl text-base text-white/70 md:text-lg">
            We live and work in Adelaide&rsquo;s south, so we&rsquo;re never far away. From the
            southern beaches to the foothills, you get a local who shows up when they say they
            will &mdash; not a call-out from across town.
          </p>
          <ul className="mt-8 flex max-w-xl flex-wrap gap-2.5" aria-label="Suburbs we service">
            {SUBURBS.map((suburb) => (
              <li
                key={suburb}
                className="flex items-center gap-1.5 border border-white/20 px-3.5 py-1.5 text-xs uppercase tracking-wider text-white/70 transition-colors duration-200 hover:border-orange hover:text-white"
              >
                <MapPin className="h-3 w-3 text-orange" aria-hidden="true" />
                {suburb}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};
